import { memo, useMemo } from 'react';

import Image from '@ubnt/link-core-ui/components/Image';
import { ClientType } from '@ubnt/wifi-calculator/device/customClients';
import { getClientTypeImage } from '@ubnt/wifi-calculator/device/images/getClientTypeImage';
import TabsPicker, { TabsPickerProps } from 'modules/bottomPanel/components/elements/TabsPicker';

import classes from './ClientTypePicker.module.scss';

const ClientTypePickerImpl = (props: Omit<TabsPickerProps, 'options'>) => {
  const options = useMemo(
    () => [
      {
        label: <Image imgClassName={classes.image} src={getClientTypeImage(ClientType.Phone)} alt="Phone" />,
        value: ClientType.Phone,
        tooltipDescription: 'Phone',
      },
      {
        label: <Image imgClassName={classes.image} src={getClientTypeImage(ClientType.Tablet)} alt="Tablet" />,
        value: ClientType.Tablet,
        tooltipDescription: 'Tablet',
      },
      {
        label: <Image imgClassName={classes.image} src={getClientTypeImage(ClientType.Laptop)} alt="Laptop" />,
        value: ClientType.Laptop,
        tooltipDescription: 'Laptop',
      },
      {
        label: <Image imgClassName={classes.image} src={getClientTypeImage(ClientType.Other)} alt="Other devices" />,
        value: ClientType.Other,
        tooltipDescription: 'Other devices',
      },
    ],
    []
  );

  return <TabsPicker label="Client Type" options={options} testId="custom-client-type" {...props} />;
};

const ClientTypePicker = memo(ClientTypePickerImpl);

export default ClientTypePicker;
